import styled from 'styled-components'

export const Actions = styled.div`
  display: flex;
  width: 100%;
  gap: ${props => props.theme.spacing.sp8};
`
